import { css } from '@emotion/react'
import { ExternalStyles, Theme, useTheme } from 'bold-ui'

export interface NewsImgProps {
  src: string
  alt: string
  width?: number
  height?: number
  style?: ExternalStyles
}

export const NewsImg = (props: NewsImgProps) => {
  const { alt, src, width, height, style } = props
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <div css={styles.main}>
      <img src={src} alt={alt} width={width} height={height} css={[styles.image, style]} />
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  main: css`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  `,

  image: css`
    max-width: 100%;
    max-height: 430px;
    height: auto;
    border: 1px solid ${theme.pallete.gray.c80};
    border-radius: ${theme.radius.button}px;
    image-rendering: -webkit-optimize-contrast;
  `,
})
